<template>
  <div class="footer-box mobile">
    <!-- 链接信息 -->

    <div class="foot1">
      <div class="foot1-left">
        <ul class="foot1-left-box">
          <li class="foot1-left-cell">
            <div class="foot1-left-cellt">关于伍斋良田</div>
            <ul class="foot1-left-cell-b">
              <li class="foot1-left-cell-c">公司简介</li>
              <li class="foot1-left-cell-c">发展历程</li>
              <li class="foot1-left-cell-c">公司分布</li>
              <li class="foot1-left-cell-c">产品优势</li>
              <li class="foot1-left-cell-c">合作伙伴</li>
            </ul>
          </li>

          <li class="foot1-left-cell">
            <div class="foot1-left-cellt">产品介绍</div>
            <ul class="foot1-left-cell-b">
              <li class="foot1-left-cell-c">粽子</li>
              <li class="foot1-left-cell-c">月饼</li>
              <li class="foot1-left-cell-c">葱油饼</li>
              <li class="foot1-left-cell-c">蛋黄焗朝牌</li>
            </ul>
          </li>

          <li class="foot1-left-cell">
            <div class="foot1-left-cellt">新闻动态</div>
            <ul class="foot1-left-cell-b">
              <li class="foot1-left-cell-c">公司新闻</li>
              <li class="foot1-left-cell-c">行业新闻</li>
            </ul>
          </li>

          <li class="foot1-left-cell">
            <div class="foot1-left-cellt">加入我们</div>
            <ul class="foot1-left-cell-b">
              <li class="foot1-left-cell-c">招聘岗位</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="foot1-right">
        <div>
          <div class="foot1-right-cellt">联系电话</div>
          <div class="foot1-phone">+86-153 7139 0000</div>
        </div>

        <div class="foot1-right-address">
          <div class="foot1-right-cellt">联系地址</div>
          <div>沭阳县杭州西路与重庆路交汇处北200米厂房第二间 。</div>
        </div>
      </div>
    </div>

    <!-- 备案信息 -->
    <div class="jsns-box">
      <div class="jsns-box-right other-info-cell">
        <div class="info-cell">
          Copyright ©宿迁伍斋良田有限公司
          <a href="https://beian.miit.gov.cn/">苏ICP备2026045612号</a>
        </div>
        <div class="info-cell">
          <a href="https://beian.miit.gov.cn/">苏公网安备32132202001558号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "myFooter",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
ul li {
  list-style: none; /* 去掉前面的圆点/数字 */
  padding: 0; /* 去掉默认的内边距（左侧缩进） */
  margin: 0; /* 去掉默认的外边距（可选） */
}
.footer-box {
  background-color: #eef0f5;
}
// 链接信息
.foot1 {
  margin: 40px;
  padding: 50px 80px;
  display: flex;
  justify-content: space-between;
  color: #999;
}

.foot1-left-box {
  display: flex;
}
.foot1-left-cell {
  margin: 0 80px 0 30px;
}
.foot1-left-cellt {
  color: #333;
  margin-bottom: 30px;
  font-weight: 700;
}
.foot1-left-cell-c {
  line-height: 32px;
}
.foot1-phone {
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  font-weight: 700;
  font-size: 36px;
  color: #c8000b;
}
.foot1-right-address {
  margin-top: 30px;
}
.foot1-right-cellt {
  line-height: 50px;
  color: #333;
  font-size: 18px;
}

.other-info-cell {
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  color: #999;
}

.jsns-box {
  padding: 10px 0;
  color: white;
  font-size: 12px;
  text-align: center;
  background-color: #333;
}

a {
  text-decoration: none;
  color: #337ab7;
}

.info-cell {
  line-height: 36px;
  height: 36px;
}

@media (max-width: 768px) {
  .mobile {
   
    .foot1 {
      margin: 0;
      padding: 30px 10px 10px 10px;
      display: block;
    }

    .foot1-left-box {
      display: flex;
      justify-content: space-between !important;
    }

    .foot1-left-cell {
      margin: 0;
    }

    .jsns-box {
      display: block;
      background-color: #333;
      background-size: cover;
      height: auto;
      .other-info-cell {
        font-size: 9px;
        display: flex;
        justify-content: space-around;
        color: #999;
      }
    }
  }
}
</style>
